export const Styles = () => {
  return {
    auto: {
      '&.MuiAutocomplete-root .MuiOutlinedInput-root .MuiAutocomplete-input': {
        padding: 0,
      },
    },
  };
};
